import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import ReactApexChart from "react-apexcharts";
import { getThousandComma } from "../../../../Api/ApiCommon";
import {
  GetAllNoHideSubsnameList,
  GetIsActivatedSubsId,
  GetSubscriptionSetData,
} from "../../../../Api/ServiceDatas";

import { useApi } from "../../../../hooks/useApi";
import LineBox from "../../../DefaultStyles/LineBox";
import { ISeries } from "../PayBoard/PayHistorySection";
import {
  DashBoardSectionTitle,
  DashBoardSectionTitleContainer,
  DashBoardViewDate,
  IndateSectionProps,
} from "../UserBoard/IndateSection";
import useIsMobile from "../../../../hooks/useIsMobile";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import Flex from "../../../DefaultStyles/Flex";
import { DropDownLabel } from "./CreateSection";
import {
  GetAllNoHideSubsnameListv3,
  getSubscriptionNameV3,
  GetSubscriptionSetData_V3,
} from "../../../../ApiTS/ServiceDatasTS_V3";
import { getSubsNameBySubsId3 } from "../../../../AdminApi/3.0_utils";

interface GatheringSectionProps extends IndateSectionProps {}

export default function GatheringSection({ filter }: GatheringSectionProps) {
  const isMobile = useIsMobile();

  const [detailList, setDetailList] = useState("");
  const [clickedLegendIndexList, setClickedLegendIndexList] = useState<
    (number | undefined)[]
  >([]);
  const [stackShowType, setStackShowType] = useState<
    "100%" | "normal" | undefined
  >("100%");
  const [series, setSeries] = useState<ISeries[]>([
    {
      name: "",
      data: [0, 0, 0, 0],
    },
  ]);
  const [subsList, setSubsList] = useState<string[]>([]);
  const [statusDropdownValue, setStatusDropdownValue] = useState<OptionType>({
    value: "0",
    label: "전체 (모집완료 + 모집중)",
  });
  const [subsDropdownValue, setSubsDropdownValue] = useState<OptionType[]>([]);

  // subscription 선택 옵션
  const subsOptionList = isMobile ? [] : [{ value: "0", label: "전체" }];
  const subsNameList = GetAllNoHideSubsnameListv3();

  for (let i = 0; i < subsNameList.length; i++) {
    const e = subsNameList[i];

    subsOptionList.push({ value: e?.split("_")[0], label: e });
  }

  const { response } = useApi({
    method: "get",
    url:
      filter.startDate !== "" && filter.endDate !== ""
        ? `dash/percent?type=party&subtype=gathering&date=${dayjs(
            filter.endDate
          )
            .add(1, "day")
            ?.format("YYYY-MM-DD")}` +
          (detailList?.length === 0 || detailList?.includes('"0"')
            ? ""
            : `&detail=${detailList}`)
        : undefined,
  });

  const optionList = [
    { label: "전체 (모집완료 + 모집중)", value: "0" },
    { label: "모집완료", value: "normal" },
    { label: "모집중", value: "gathering" },
  ];

  useEffect(() => {
    let subsList: string[] = [];
    let normalData: number[] = [];
    let gatheringData: number[] = [];

    if (response?.status === 200) {
      for (let i = 0; i < response?.data.length; i++) {
        const element = response?.data[i];

        if (Number(element?.detail)) {
          const subsData = GetSubscriptionSetData_V3(Number(element.detail));

          normalData.push(element?.data?.normal ?? 0);
          gatheringData.push(element?.data?.gathering ?? 0);

          subsList.push(
            `${subsData?.SUBS_ID}_${getSubsNameBySubsId3(
              Number(element.detail)
            )}`
          );
        }
      }

      setSeries(
        statusDropdownValue?.value === "normal"
          ? [
              {
                name: "모집완료",
                data: normalData,
              },
            ]
          : statusDropdownValue?.value === "gathering"
          ? [
              {
                name: "모집중",
                data: gatheringData,
              },
            ]
          : [
              {
                name: "모집완료",
                data: normalData,
              },
              {
                name: "모집중",
                data: gatheringData,
              },
            ]
      );
      setSubsList(subsList);
    }
  }, [response, statusDropdownValue, subsDropdownValue]);

  useEffect(() => {
    const normalClickedCount = clickedLegendIndexList.filter(
      (x) => x === 0
    ).length;
    const gatheringClickedCount = clickedLegendIndexList.filter(
      (x) => x === 1
    ).length;

    if (normalClickedCount % 2 !== 0 || gatheringClickedCount % 2 !== 0) {
      setStackShowType("normal");
    } else {
      setStackShowType("100%");
    }
  }, [clickedLegendIndexList]);

  useEffect(() => {
    const arr: string[] = [];
    const keyArr: string[] = [];

    console.log(subsDropdownValue);

    for (let i = 0; i < subsDropdownValue.length; i++) {
      const element = subsDropdownValue[i];

      if (element.value === "0") {
        setSubsDropdownValue([]);
      }

      arr.push(`"${element?.value}"`);
      keyArr.push(`${element?.value}`);
    }

    setDetailList(arr.toString());
  }, [subsDropdownValue]);

  return (
    <>
      <DashBoardSectionTitleContainer>
        <DashBoardSectionTitle>파티 모집 현황</DashBoardSectionTitle>

        <Flex gapSize={10}>
          <DropDown
            isDisabled={false}
            initText="전체"
            optionList={subsOptionList}
            dropdownMultiValue={subsDropdownValue}
            setDropDownMultiValue={setSubsDropdownValue}
            isMulti={true}
            initValue={"0"}
          />

          <DropDown
            isDisabled={false}
            initText="상태 선택"
            setDropDownValue={setStatusDropdownValue}
            optionList={optionList}
            dropdownValue={statusDropdownValue}
          />
        </Flex>
      </DashBoardSectionTitleContainer>

      <LineBox boxPadding={"28px 32px"}>
        <DropDownLabel>
          {detailList?.split(",")?.map((d) => {
            const subsId = d?.replaceAll('"', "");

            if (d !== "") {
              return `${getSubscriptionNameV3(+subsId ?? 0)}${
                detailList?.split(",")[detailList?.split(",")?.length - 1] !==
                  d && detailList?.split(",")?.length > 1
                  ? ", "
                  : ""
              }`;
            }
          })}
        </DropDownLabel>

        <DashBoardViewDate isMobile={isMobile}>
          {filter.endDate} 기준
        </DashBoardViewDate>

        <div style={{ width: "100%", height: 800 }}>
          <ReactApexChart
            type="bar"
            height={800}
            series={series}
            options={{
              colors:
                statusDropdownValue?.value === "gathering"
                  ? ["#00E396"]
                  : undefined,
              chart: {
                type: "bar",
                height: 350,
                stacked: statusDropdownValue?.value === "0" ? true : false,
                // stackType: "normal",
                // stackType: "100%",
                stackType:
                  statusDropdownValue?.value === "0" ? "100%" : "normal",
                toolbar: {
                  show: false,
                },
                zoom: {
                  enabled: false,
                },
                events: {
                  legendClick(chart, seriesIndex?, options?) {
                    setClickedLegendIndexList((prev) => [...prev, seriesIndex]);
                  },
                },
              },

              grid: {
                xaxis: {
                  lines: {
                    show: true,
                  },
                },
                yaxis: {
                  lines: {
                    show: false,
                  },
                },
              },
              plotOptions: {
                bar: {
                  horizontal: true,
                  dataLabels: {
                    hideOverflowingLabels: true,
                  },
                  borderRadius: 10,
                  barHeight: "70%",
                },
              },
              dataLabels: {
                formatter: (val, { w }) => {
                  if (Math.round(Number(val) * 10) / 10 > 3)
                    return `${Math.round(Number(val) * 10) / 10}${
                      statusDropdownValue?.value === "0" ? "%" : "명"
                    }`;
                  return "";
                },
                textAnchor: "middle",
              },
              stroke: {
                width: 1,
                colors: ["#fff"],
              },
              xaxis: {
                categories: subsList,
                max:
                  statusDropdownValue?.value === "gathering"
                    ? 100
                    : statusDropdownValue?.value === "normal"
                    ? 1000
                    : undefined,
              },
              tooltip: {
                y: {
                  formatter: (val) => {
                    return getThousandComma(val) + "명";
                  },
                },
                followCursor: true,
              },
              fill: {
                opacity: 1,
              },
              legend: {
                position: "top",
                horizontalAlign: "center",
                offsetX: 40,
                fontFamily:
                  "-apple-system, BlinkMacSystemFont, 'Apple SD Gothic Neo', Pretendard Variable, Roboto, 'Noto Sans KR', 'Segoe UI', 'Malgun Gothic', sans-serif",
                markers: {
                  width: 10,
                  height: 10,
                  offsetX: -4,
                  radius: 10,
                },
                fontSize: "13px",
                fontWeight: 500,
                itemMargin: {
                  horizontal: 16,
                },
              },
            }}
          />
        </div>
      </LineBox>
    </>
  );
}
